(function($) {

    //if the alert is visible,  need to push it down.
    var primaryNavigation = $('#primaryNavigation');
    let baseOffsetTop = (primaryNavigation.offset().top);
    let newOffsetTop = baseOffsetTop + $('.pr-alert:first').outerHeight();
    primaryNavigation.css('top', newOffsetTop);

    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('#primaryNavigation');
        $this = $(this);

        



        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-active')) {
            primaryNavigation.removeClass('is-active');
            $('body').removeClass('no-scroll');
            $this.addClass('collapsed');

        } else {
            primaryNavigation.addClass('is-active');
            $('body').addClass('no-scroll');
            $this.removeClass('collapsed');
        }
    });

    // Toggle mobile sub menu
    $('.dropdown-title.has-sub').on('click', function() {
        $this = $(this);

        $this
            .closest('.sub-container')
            .find('.menu-secondary')
            .addClass('is-active');
    });

    $('.js-overlay-back').on('click', function() {
        $this
            .closest('.sub-container')
            .find('.menu-secondary')
            .removeClass('is-active');
    });

    // Prevent dropdown from closing when clicking outside of anchor
    $('.dropdown-menu').on('click', function(e) {
        e.stopPropagation();
    });

    if ($(window).width() <= 991) {
        $('#siteHeader .dropdown-toggle').on('click', function() {
            $('body').addClass('no-scroll');
            $('.navbar-toggle').addClass('is-hidden');
            $('.navbar-toggle-sub').addClass('is-visible');
        });
    }

    // Disable sub nav when close icon is clicked
    $('#navbarToggleSub').on('click', function() {
        $('body').removeClass('no-scroll');
        $('.navbar-toggle').addClass('collapsed').removeClass('is-hidden');
        $('.navigation-collapse').removeClass('is-active');
        $(this).removeClass('is-visible');
    });

}(jQuery));
